import DOMPurify from 'dompurify';

/**
 * Remove scripts, handlers de evento (onerror, onclick...), iframes e URLs javascript:
 * de HTML vindo de livros, EPUBs, descrições de audiobooks ou do R2, antes de usar em
 * dangerouslySetInnerHTML. Mantém estrutura, classes, ids, estilos e data-* usados pelo leitor.
 */
// Cache pequeno: componentes que re-renderizam a cada tique de áudio não re-sanitizam o mesmo HTML
const cache = new Map<string, string>();
const CACHE_MAX = 20;

export function sanitizeHtml(html: string | null | undefined): string {
    if (!html) return '';
    const hit = cache.get(html);
    if (hit !== undefined) return hit;
    const clean = DOMPurify.sanitize(html, {
        FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'base', 'meta', 'link'],
        FORBID_ATTR: ['srcdoc', 'formaction'],
    });
    if (cache.size >= CACHE_MAX) cache.delete(cache.keys().next().value as string);
    cache.set(html, clean);
    return clean;
}
